import { NavigateFunction } from '@lune/common/paths'
import { IconButton } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  RemoveAliasIcon,
  MoveAliasIcon,
  PermanentDeleteIcon
} from '../../icons'
import { AliasMove } from '../../paths'

export const RemoveGroupButton: React.FC<{ onClick: () => void }> = ({
  onClick
}) => (
  <IconButton onClick={onClick}>
    <PermanentDeleteIcon />
  </IconButton>
)

export const RemoveAliasButton: React.FC<{
  selected: boolean
  onClick: () => void
}> = ({ selected, onClick }) => (
  <IconButton onClick={onClick} disabled={selected}>
    <RemoveAliasIcon />
  </IconButton>
)

export const MoveAliasButton: React.FC<{
  alias: string
  onNavigate?: NavigateFunction
}> = ({ alias, onNavigate }) => {
  const navigateFn = useNavigate()
  const navigate = onNavigate ?? navigateFn
  return (
    <IconButton
      onClick={() => {
        navigate(`${AliasMove}?alias=${alias}${window.location.hash}`)
      }}
    >
      <MoveAliasIcon />
    </IconButton>
  )
}
